import React from 'react';
import { Chip } from 'common/react/components/Chip';
import { getTranslation } from 'common/react/utils/translations';
import PropTypes from 'prop-types';

export const BPLeaderboardTooltip = ({ seasonPid }) => {
    const infoText = getTranslation(
        `label.playerAwards.predictor.tooltipText.${seasonPid}`
    );

    return (
        <div className="chip__list-wrapper">
            <div className="chip__list">
                <Chip
                    bgColour="rgb(var(--fill-accent-primary-rgb) / 8%)"
                    symbolColour="var(--fill-accent-primary)"
                    symbol="●"
                    label={getTranslation('label.votesPredicted')}
                    showBorder={false}
                />
                <Chip
                    bgColour="rgb(0 0 0 / 12%)"
                    symbolColour="rgb(82 82 82)"
                    symbol="●"
                    label={getTranslation('label.ineligible')}
                    showBorder={false}
                />
                <Chip
                    bgColour="rgb(0 0 0 / 6%)"
                    label={getTranslation('label.noVotes')}
                    showBorder={false}
                />
                <Chip
                    bgColour="rgb(0 0 0 / 12%)"
                    label={getTranslation('label.upcoming')}
                    hollow
                />
                <Chip
                    bgColour="rgb(0 0 0 / 0%)"
                    symbolColour="rgb(0 0 0 / 12%)"
                    symbol="-"
                    label={getTranslation('label.didNotPlay')}
                />
                <Chip
                    bgColour="rgb(0 0 0 / 6%)"
                    symbolColour="rgb(118 118 118)"
                    symbol="B"
                    label={getTranslation('label.fixtures.group.title.bye')}
                    className="chip__square-symbol--large"
                    showBorder={false}
                />
            </div>
            {infoText && (
                <div
                    className="chip__info-text"
                    dangerouslySetInnerHTML={{ __html: infoText }}
                ></div>
            )}
        </div>
    );
};

BPLeaderboardTooltip.propTypes = {
    seasonPid: PropTypes.string
};
